interface WizardHeaderProps {
  label: string;
  description: string;
  isOptional?: boolean;
  currentStep: number;
  totalSteps: number;
  isSaving: boolean;
  isValid: boolean;
  onPrevious: () => void;
  onSkip: () => void;
  onSave: () => void;
  onNext: () => void;
}

export function WizardHeader({
  label,
  description,
  isOptional,
  currentStep,
  totalSteps,
  isSaving,
  isValid,
  onPrevious,
  onSkip,
  onSave,
  onNext,
}: WizardHeaderProps) {
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(8px)',
        padding: '1.5rem 2.5rem',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 10px rgba(0,0,0,0.02)',
      }}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.25rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#00303c', margin: 0 }}>{label}</h2>
          {isOptional && (
            <span
              style={{
                padding: '0.2rem 0.6rem',
                background: '#f3f4f6',
                color: '#6b7280',
                borderRadius: '6px',
                fontSize: '0.75rem',
                fontWeight: 600,
              }}
            >
              Optionnel
            </span>
          )}
        </div>
        <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>{description}</p>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <button
          onClick={onPrevious}
          disabled={isFirstStep || isSaving}
          style={{
            padding: '0.6rem 1rem',
            background: 'transparent',
            color: isFirstStep ? '#ccc' : '#4b5563',
            border: '1px solid',
            borderColor: isFirstStep ? '#e5e7eb' : '#d1d5db',
            borderRadius: '8px',
            fontSize: '0.9rem',
            fontWeight: 600,
            cursor: isFirstStep ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
            if (!isFirstStep && !isSaving) e.currentTarget.style.background = '#f9fafb';
            }}
            onMouseLeave={(e) => {
            if (!isFirstStep) e.currentTarget.style.background = 'transparent';
            }}
            >
            Précédent
            </button>

            {isOptional && !isLastStep && (
            <button
            onClick={onSkip}
            disabled={isSaving}
            style={{
              padding: '0.6rem 1rem',
              background: 'transparent',
              color: '#6b7280',
              border: '1px solid transparent',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: 600,
              cursor: isSaving ? 'not-allowed' : 'pointer',
            }}
            onMouseEnter={(e) => {
              if (!isSaving) e.currentTarget.style.background = '#f3f4f6';
            }}
            onMouseLeave={(e) => {
              if (!isSaving) e.currentTarget.style.background = 'transparent';
            }}
            >
            Passer
            </button>
            )}

            <button
            onClick={onSave}
            disabled={isSaving || !isValid}
            style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.6rem 1.25rem',
            background: isSaving ? '#e5e7eb' : 'white',
            color: isSaving ? '#999' : '#00758d',
            border: '1px solid #00758d',
            borderRadius: '8px',
            fontSize: '0.9rem',
            fontWeight: 600,
            cursor: isSaving ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
            if (!isSaving) {
              e.currentTarget.style.background = '#00758d';
              e.currentTarget.style.color = 'white';
            }
            }}
            onMouseLeave={(e) => {
            if (!isSaving) {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.color = '#00758d';
            }
            }}
            >
            {isSaving && (
            <svg
              className="animate-spin"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            )}
            {isSaving ? 'Sauvegarde...' : 'Sauvegarder'}
            </button>

            <button
            onClick={onNext}
            disabled={!isValid || isSaving}
            style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.6rem 1.5rem',
            background: isValid && !isSaving ? '#00303c' : '#e5e7eb',
            color: isValid && !isSaving ? 'white' : '#999',
            border: 'none',
            borderRadius: '8px',
            fontSize: '0.9rem',
            fontWeight: 600,
            cursor: isValid && !isSaving ? 'pointer' : 'not-allowed',
            transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
            if (isValid && !isSaving) {
              e.currentTarget.style.background = '#00758d';
            }
            }}
            onMouseLeave={(e) => {
            if (isValid && !isSaving) {
              e.currentTarget.style.background = '#00303c';
            }
            }}
            >          {isLastStep ? 'Terminer' : 'Suivant'}
        </button>
      </div>
    </div>
  );
}
